import { render, staticRenderFns } from "./anchor.vue?vue&type=template&id=7fe03bca"
var script = {}


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports